import React from 'react';
import '../assets/style/services.css'
import { Link } from 'react-router-dom'

import { MdMobileFriendly } from 'react-icons/md'
import { TbTriangleSquareCircle } from 'react-icons/tb'
import { BsBoxes } from 'react-icons/bs'

const Services = () => {
    return (
        <>
            <div className="services">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-md-4 sv-left">
                            <h2>Services</h2>
                            <h3 className="grad">My Expertise<span className='blink'>_</span></h3>

                            <p>
                                I specialize in Frontend, Full Stack, and WordPress development, building scalable, responsive, and high-performance web applications. I have strong experience with HTML, CSS, JavaScript, TypeScript, React.js, Next.js, and WordPress, along with backend technologies like Node.js, PHP, MySQL, and REST API integration to create complete digital solutions.
                            </p>

                            <h4>What you can expect</h4>
                            <ul>
                                <li>Responsive Frontend Development</li>
                                <li>Full Stack Web Applications</li>
                                <li>Custom WordPress Development</li>
                            </ul>

                            <h4>Technologies I work with</h4>
                            <ul>
                                <li>React.js & Next.js</li>
                                <li>JavaScript & TypeScript</li>
                                <li>WordPress, PHP & MySQL</li>
                            </ul>

                            <div className="btn-bg mt-32">
                                <Link to="/contact">
                                    <button className='download-btn w-100'>Contact</button>
                                </Link>
                            </div>
                        </div>

                        <div className="col-12 col-md-8 sv-right">
                            <div className="card">
                                <div className="card-grad">
                                    <MdMobileFriendly className='card-icon' />
                                    <h2>Frontend Development</h2>
                                </div>
                                <div className="card-content">
                                    <p>
                                        Building modern, responsive, and user-friendly interfaces using React.js, Next.js, JavaScript, and TypeScript with a focus on performance and scalability.
                                    </p>
                                    <ul>
                                        <li>Responsive UI Development</li>
                                        <li>React.js & Next.js Applications</li>
                                        <li>Performance Optimization</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="card">
                                <div className="card-grad">
                                    <TbTriangleSquareCircle className='card-icon' />
                                    <h2>Full Stack Development</h2>
                                </div>
                                <div className="card-content">
                                    <p>
                                        Developing complete web applications from frontend to backend with API integration, authentication systems, database management, and scalable architecture.
                                    </p>
                                    <ul>
                                        <li>REST API Integration</li>
                                        <li>Backend Development</li>
                                        <li>Database Management</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="card">
                                <div className="card-grad">
                                    <BsBoxes className='card-icon' />
                                    <h2>WordPress Development</h2>
                                </div>
                                <div className="card-content">
                                    <p>
                                        Creating custom WordPress websites, themes, and business solutions with optimized performance, responsive layouts, and easy content management.
                                    </p>
                                    <ul>
                                        <li>Custom WordPress Websites</li>
                                        <li>Theme Customization</li>
                                        <li>Website Maintenance & Optimization</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Services;